import React from "react";
import { X } from "lucide-react";
import SOCIAL_NETWORKS from "../constants/socialNetworks.js";

const COPY_URL = "https://соц-план.рф/?utm_source=copy";
const SHARE_BASE = "https://соц-план.рф/";
const SHARE_CAMPAIGN = "share_main";
const SHARE_TEXT = "СоцПлан — генератор бизнес-планов для соцконтракта";

export default function ShareSiteModal({ onClose }) {
  const [copied, setCopied] = React.useState(false);

  const onCopy = async () => {
    try {
      await navigator.clipboard.writeText(COPY_URL);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch (_) {
      // noop
    }
  };

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-slate-900/40 px-4 py-6">
      <div className="relative w-full max-w-lg rounded-2xl bg-white p-6 shadow-xl">
        <button
          type="button"
          onClick={onClose}
          className="absolute right-4 top-4 rounded-full p-1 text-slate-500 hover:bg-slate-100 hover:text-slate-700"
          aria-label="Закрыть"
        >
          <X className="h-5 w-5" />
        </button>
        <h2 className="text-xl font-semibold text-slate-900">Поделиться сайтом</h2>
        <div className="mt-3 text-sm leading-relaxed text-slate-600" />
        <div className="mt-4 rounded-xl border border-slate-200 bg-slate-50 p-4">
          <div className="text-xs uppercase tracking-wide text-slate-500">Ссылка</div>
          <a
            href={COPY_URL}
            className="mt-1 block break-all font-medium text-blue-600 hover:text-blue-700"
            target="_blank"
            rel="noopener noreferrer"
          >
            {COPY_URL}
          </a>
          <div className="mt-2 flex items-center gap-3 text-xs text-emerald-600">
            <button
              type="button"
              onClick={onCopy}
              className="inline-flex items-center rounded border border-emerald-300 px-2 py-1 text-emerald-700 hover:bg-emerald-50"
            >
              {copied ? "Скопировано" : "копировать"}
            </button>
          </div>
        </div>
        <div className="mt-6 grid grid-cols-3 gap-3">
          {SOCIAL_NETWORKS.map((item) => {
            const shareUrl = `${SHARE_BASE}?utm_source=${item.id}&utm_medium=social&utm_campaign=${SHARE_CAMPAIGN}`;
            const href = item.buildHref(shareUrl, SHARE_TEXT);
            return (
              <a
                key={item.id}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                className="flex flex-col items-center justify-center rounded-xl border border-slate-200 p-3 text-center text-sm font-medium transition bg-white text-slate-700 hover:border-transparent hover:shadow"
              >
                <span className={`mb-2 flex h-12 w-12 items-center justify-center rounded-full text-white ${item.color}`}>
                  {item.icon}
                </span>
                {item.name}
              </a>
            );
          })}
        </div>
      </div>
    </div>
  );
}
